"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _iconBase = _interopRequireDefault(require("@kbbcomponentlibrary/icon-base"));

/*eslint import/namespace: ['error', { allowComputed: true }]*/
var IconChevronUp = function IconChevronUp(props) {
  return _react["default"].createElement(_iconBase["default"], props, _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M5.70710678,15.7071068 C5.31658249,16.0976311 4.68341751,16.0976311 4.29289322,15.7071068 C3.90236893,15.3165825 3.90236893,14.6834175 4.29289322,14.2928932 L11.2928932,7.29289322 C11.6834175,6.90236893 12.3165825,6.90236893 12.7071068,7.29289322 L19.7071068,14.2928932 C20.0976311,14.6834175 20.0976311,15.3165825 19.7071068,15.7071068 C19.3165825,16.0976311 18.6834175,16.0976311 18.2928932,15.7071068 L12,9.41421356 L5.70710678,15.7071068 Z"
  })));
};

IconChevronUp.displayName = 'IconChevronUp';
var _default = IconChevronUp;
exports["default"] = _default;
IconChevronUp.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "IconChevronUp",
  "props": {
    "size": {
      "required": true,
      "flowType": {
        "name": "number"
      },
      "description": ""
    },
    "viewBox": {
      "required": true,
      "flowType": {
        "name": "string"
      },
      "description": ""
    },
    "colorFill": {
      "required": true,
      "flowType": {
        "name": "string"
      },
      "description": ""
    },
    "children": {
      "required": false,
      "flowType": {
        "name": "ReactElement",
        "raw": "React.Element<*>",
        "elements": [{
          "name": "unknown"
        }]
      },
      "description": ""
    }
  }
};

if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/ChevronUp.js"] = {
    name: "IconChevronUp",
    docgenInfo: IconChevronUp.__docgenInfo,
    path: "src/ChevronUp.js"
  };
}